import {
  Box,
  Typography,
} from "@mui/material";

import AssessmentIcon from "@mui/icons-material/Assessment";

export default function ReportNoData({
  text = "No data available",
}) {
  return (
    <Box
      py={8}
      textAlign="center"
    >
      <AssessmentIcon
        color="disabled"
        sx={{
          fontSize: 60,
          mb: 2,
        }}
      />

      <Typography
        variant="h6"
        color="text.secondary"
      >
        {text}
      </Typography>
    </Box>
  );
}